const page = `

{settings}
document.title: Fem år efter Utøya
og.title: Fem år efter Utøya
og.image: http://quickshot.imgix.net/fem-ar-efter-utoya/utoyaa.jpg?w=1000
og.description: I år är det fem år sedan Anders Behring Breivik mördade 77 personer – och skrev in sig i historieböckerna som den värste terrorist Norden någonsin har sett.
og.url: http://pejl.svt.se/fem-ar-efter-utoya/
siteCatalyst.name: fem-ar-efter-utoya
siteCatalyst.category: lyxartikel
{}

[+page]

rubrik2: ”Det är någon som skjuter på Utøya”

rubrikmager: [Jag tror att det här blir mitt sista inlägg. Det är nu fredagen den 22 juli, 12.51. | em]


Det är strax efter lunch, den 22 juli 2011. 32-årige Anders Behring Breivik sitter i sitt hem och skriver några ord i en dagbok. Ännu vet ingen vad han i flera år planerat, vad som ska hända under timmarna som nu följer.

I slutet av den här dagen kommer en panikslagen ung kvinna att ringa sin mamma och berätta att det är någon som skjuter på ön där hon befinner sig. En nioårig pojke kommer att förlora sin pappa. En ung man kommer att se döden rakt i ögonen innan hans liv är över.

ingress: Innan den här sommardagen är slut kommer Norge att ha skakats av det värsta terrordådet som skett i Norden i modern tid.
{.sharebuttons}
title: Fem år efter Utøya
url:http://pejl.svt.se/fem-ar-efter-utoya/
{}

{.bild}
fil: fem-ar-efter-utoya/utoyaforsta.jpg
storlek: xl
imgix.crop:top
{}
luft:
rubrikmager: [08.29|tid] – De sista förberedelserna
Anders Behring Breivik, en 32-årig man från Oslo, har länge och noggrant planerat det han om några timmar tänker genomföra. Han har sedan några år tillbaka blivit alltmer extrem i sina övertygelser och tillbringar mycket tid på nätet där han bland annat skrivit i ett nazistiskt nätforum. Han kallar sig för nationalist och vill se en antimuslimsk rörelse i Norge.

rubrik4: Läs mer: [Klasskamraten som blev massmördare | http://www.svt.se/nyheter/utrikes/20110725162840_klasskamraten_som_blev_massmordare]

Han har förberett sig, flyttat ut på landsbygden. Sparat pengar till, tillverkat och provsprängt en bomb med potential att döda. Han har distanserat sig från vänner, tagit avstånd från kvinnor för att inte distraheras från sin plan. Han har tränat upp sin kropp och ätit anabola steroider för att bygga muskler – muskler han beräknat att han kommer att behöva den här dagen.

{.bild}
fil: fem-ar-efter-utoya/breivikhus.jpg
storlek: wide
bildtext: Anders Behring Breivik flyttar ut till en gård, där tillverkar han bomben han senare kommer att använda i attacken mot Oslo.
foto: TT
{}

I ett 1.500 sidor långt dokument redogör han för sin världsbild – en världsbild som präglas av hat mot multikulturalism och det han beskriver som "kulturmarxister".
I slutet av "manifestet", som han kallar det, har Anders Behring Breivik beskrivit hur planerna över ett terrorattentat fortskridit och intensifierats de senaste månaderna.
Ända fram till den här dagen.


{.citat}
citat: Jag har mer eller mindre en perfekt kropp just nu och jag är gladare än vad jag någonsin varit tidigare.
av: Anders Behring Breivik, maj 2011
{}

{.bild}
fil: fem-ar-efter-utoya/breivik.jpg
storlek: xl
bildtext: Mannen som ska komma att bli den värsta terroristen i Norden i modern tid. Anders Behring Breivik.
foto: TT
{}

luft:
rubrikmager: [12.03|tid] – Flyktbilen är på plats

En silvergrå Fiat Doblo ställs på parkeringsplatsen i Hammersborg torg, i centrala Oslo. Det här är bilen Anders Behring Breivik har planerat att fly i, efter att han genomfört sitt första attentat.

Övervakningsbilder fångar Breivik då han under ett paraply lugnt promenerar runt i regeringskvarteret. Under armen har han en svart dokumentmapp. Han kommer senare i förhör berätta att promenaden är en ”rekognoseringsrunda” , och att mappen ska hjälpa honom att ”smälta in” i området.
Spaningen av området har Breivik, enligt honom själv, arbetat med under tre år.


{.bild}
fil: fem-ar-efter-utoya/breivikinnan1.jpg
storlek: wide
bildtext:
{}

Från regeringskvarteret tar Anders Behring Brevik en taxi hem till sin mamma. I sitt pojkrum sätter han sig ner framför datorn. Manifestet skickas ut till omkring 1.000 norska och utländska e-postadresser. Han signerar det med pseudonymen Anders Berwick.

Nu är han redo för nästa fas – den första attacken, rakt mot Oslos politiska hjärta.

{.bild}
fil: fem-ar-efter-utoya/CentralaOslo002.jpg
storlek: m
bildtext: Bomben exploderade i H-blocket, eller Høyblokka, där bland andra statsminister Jens Stoltenberg sitter.
{}
[1|kula] – H-blocket[ |marginal] [2|kula] – S-blocket[ |marginal] [3|kula] – R4[ |marginal] [4|kula] – G-blocket[ |marginal] [5|kula] – Högsta domstolen[ |marginal] [6|kula] – tidningen Verdens Gang[ |marginal] [7|kula] – R5[ |marginal] [8|kula] – Y-blocket[ |marginal] [9|kula] – Brandstationen [10|kula] – Norska Arbetarpartiet

luft:
rubrikmager: [15.16|tid] – En bomb i centrala Oslo

Breivik kör bombbilen, en Volkswagen Crafter, in i centrala Oslo och hela vägen fram till huvudingången till Høyblokka – en av byggnaderna i regeringskvarteret där bland andra statsminister Jens Stoltenberg har sitt kontor. Vägen är egentligen förbjuden för privatbilar, men Breivik stoppas inte.
Framme vid parkeringen upptäcker Anders Behring Breivik att platsen där han hade tänkt parkera, med vänstersidan av bilen mot byggnaden, är upptagen. Han får tänka om. Planen är, kommer han själv senare att berätta i förhör, att jämna hela huset med marken.

{.bild}
fil: fem-ar-efter-utoya/bombbilen.jpg
storlek: wide

{}
Utanför Høyblokka fångas Anders Behring Breivik på bild, iklädd en polisuniform.  Han lämnar lugnt bilen och tar sig till fots till flyktbilen som står parkerad en bit bort. En vakt som sett Breivik parkera tänker just ringa för att meddela att en bil felparkerats och måste flyttas.

I samma stund detonerar den 950 kilo tunga bomben.


{.bild}
fil: fem-ar-efter-utoya/regeringshus1.jpg
storlek: xl
foto: TT

{}
rubrikmager: [15.26|tid] – Staden är en krigszon


Bomben är så kraftig att fasaden på den K-märkta byggnaden spricker. Inuti byggnaden befinner sig 65 personer, en av dem är Line Nersnaes. Hon står vid sin arbetsplats på justitiedepartementet när explosionen sker. När hon kommer ut från byggnaden upptäcker hon att en träpinne har fastnat i hennes huvud.

Explosionen orsakar stor förödelse, bland annat rivs ett hål upp i väggen till statsminister Jens Stoltenbergs kontor. I en senare rekonstruktion av bomben berättar en norsk bombexpert att den bland annat består av konstgödsel – och hur den kunde orsaka så stora skador.
{.citat}
citat: Om bomben finns i en bil gör trycket att bilen blir upplöst i småbitar. Fragmenten slungas i väg 1.000 meter per sekund. Fragmenten är alltså små stålbitar.
av: Bombexpert Svein Olav Christensen
{}

Tryckvågen får fönster inom en radie på flera hundra meter att krossas. Vittnen beskriver centrala Oslo som en krigszon.
Åtta personer dödas i attentatet mot regeringsbyggnaden. 209 skadas i explosionen, nio av dem allvarligt. Men ännu är inte terrorangreppet över.

{.iframe}
src: http://pejl.svt.se/stage/fem-ar-efter-otoya-galleri/oslo.html
storlek: m
height: 500px
{}
luft:
rubrikmager: [15.55|tid] – Mannen i polisuniform

Polisen har nåtts av larmet om explosionen i regeringskvarteret och en särskild insatsstyrka, Delta, har mobiliserats.

Det enda vittne som stött på Anders Behring Breivik kontaktar polisen och berättar att han sett en man med nordiskt utseende lämna platsen fem minuter före explosionen. Vittnet berättar också att mannen han sett bär polisuniform och är beväpnad med pistol.


{.bild}
fil: fem-ar-efter-utoya/overvakningsbild1.jpg
storlek: square
bildtext: Breivik fångas av en övervakningskamera på väg bort från bombplatsen.
foto: TT
{}


Klockan 16.43 skickar den norska polisen ut ett rikslarm, tillsammans med en intern efterlysning. Vittnet har kunnat uppge registreringsnumret på Breiviks flyktbil, som man nu jagar.

Samtidigt är Anders Behring Breivik, fortfarande iklädd polisuniform, på väg mot ön Utøya där det norska socialdemokratiska ungdomsförbundet, AUF, har sitt årliga sommarläger.

Här har han planerat sin nästa attack.


{.bild}
fil: fem-ar-efter-utoya/utoya.jpg
storlek: xl
bildtext: Ön Utøya skänktes 1950 till det norska socialdemokratiska ungdomsförbundet AUF. Varje år håller man sommarläger på ön.
foto: TT
{}

luft:
rubrikmager: [17.04|tid] – ”En polis vill till Utøya”

Det årliga sommarlägret på Utøya är inne på sin tredje dag. 560 lägerdeltagare från det norska socialdemokratiska ungdomsförbundet befinner sig på ön.

Klockan 16.57 har kaptenen på den båt som tar människor från fastlandet till ön fått besked om att han ska hämta en polisman som vill komma över till Utøya. Ungefär fem minuter senare är båten ”MS Thorbjørn” på väg mot ön, med Anders Behring Breivik ombord.

rubrik4: Läs mer: [Han skjutsade Breivik till ön | http://www.svt.se/nyheter/utrikes/han-skjutsade-breivik-minuter-senare-mordas-sambon]

Förutom kaptenen finns även hans sambo, Monica Bøsei, ombord på båten. Monica kallas för ”Mor Utøya” av alla på ön, eftersom hon arbetat med sommarlägren i över 20 år. Under resan från fastlandet diskuterar hon terrorattacken i Oslo med mannen i polisuniform, hon undrar varför han vill åka ut till lägerön.

Monica kommer snart att bli en av de första personerna som skjuts till döds av Anders Behring Breivik den här dagen.

{.bild}
fil: fem-ar-efter-utoya/msthorbjorn.jpg
storlek: wide
bildtext: Kaptenen som kör båten ut till Utøya med Anders Behring Brevik använde senare båten för att rädda överlevande från ön.
foto: TT
{}


luft:
rubrikmager: [17.20|tid] – Det första offret

När båten MS Thorbjørn når Utøya kommer öns egen polisman Trond Berntsen ner till strandkanten. Kaptenen kommer senare i ett vittnesmål att berätta hur han ser polismannen ta Breivik i hand. Sedan skjuts Trond Berntsen till döds.

Monica Bøsei skjuts strax innan eller efter Trond Berntsen, kaptenen har i efterhand inte kunnat minnas vem som dödas först. Men kort därefter fortsätter Anders Behring Breivik upp emot lägerbyggnaderna – samtidigt som kaptenen flyr för sitt liv. Hans livskamrat har precis skjutits ihjäl och hans dotter befinner sig någonstans på ön tillsammans med över 500 andra ungdomar.

Mardrömmen har börjat, och Utøyas väktare är döda.

{.bild}
fil: fem-ar-efter-utoya/forstaoffer.jpg
storlek: wide
bildtext: Monica Bøsei arbetade med sommarlägrena på Utøya, Trond Berntsen var polis på ön.
foto: TT
{}


{.citat}
citat: Jag vänder mig om och börjar springa. Jag väntar hela tiden på att få ett skott i ryggen, för det är helt öppet. Jag börjar tänka på det som kommer ske.
av: Kaptenen på MS Thorbjørn
{}


luft:
rubrikmager: [17.24 |tid] – Ingen är säker på ön

Anders Behring Breivik tar sig från båten upp till huvudbyggnaden, som har två samlingssalar. Han kallar först till sig några av ungdomarna som kommer fram till vad de tror är en polisman som ska prata med dem om explosionen som nyss skett i Oslo.

De blir Breiviks nästa offer.

Därefter går han vidare till ett tältläger som ligger en bit bort och fortsätter att skjuta urskillningslöst. Ungefär vid den här tiden kommer de första samtalen in till norska larmcentralen och polisen. Det allra första samtalet polisen nås av är en skräckslagen ung kvinna vars pojkvän just skjutits ihjäl framför hennes ögon. Hon heter Renate Tårnes och ringer från sitt gömställe på lägercaféets toalett.

I bakgrunden hörs öronbedövande dån av Breiviks vapen. På andra sidan dörren, i caféet, dödas tretton personer.


{.citat}
citat: Det pågår skottlossning här på Utøya.
av: Renate Tårnes, överlevande
{}

17-åriga Stine Brandvik befinner sig i huvudbyggnaden när hon hör de första skotten. På sin väg ut står hon plötsligt öga mot öga med personen hon tror kommer att bli hennes mördare. Men under de sekunder det tar Anders Behring Breivik att ladda om sitt vapen lyckas hon fly – med en femårig pojke i famnen.


{.citat}
citat: När han laddar om vet jag att vi har tre, fyra sekunder att springa på. Vi sprang genom korridoren och jag kände hur fyra kulor ven kring mitt huvud.
av: Stine Brandvik, överlevande
{}

Ungdomarna flyr i panik, men Anders Behring Breivik följer efter. Bakom det lilla pumphuset nere vid vattnet ligger flera ungdomar, tysta, och gömmer sig för skotten. Men det dröjer inte länge innan de får syn på polismannen, som dyker upp i ena änden av huset. Någon ber honom visa någon slags bevis för att han är polis.

Han svarar att de ska ta det lugnt. Sedan börjar han att skjuta.


{.citat}
citat:  Han hade ett stenansikte. Jag ser rätt på honom. Han hade blå ögon och var nyrakad
av: Lars Öberg, överlevande
{}

{.bild}
fil: fem-ar-efter-utoya/pumphuset.jpg
storlek: wide
bildtext: Vid pumphuset på Utøya skjuts flera ungdomar ihjäl av Anders Behring Breivik.
foto: TT
{}

Under de kommande minuterna är ingen säker. Anders Behring Breivik tar sig lugnt och metodiskt fram längs vattenbrynet. Han skjuter alla han kommer åt. Breivik kommer senare i rätten att berätta att han två gånger avstår från att skjuta – den ena tyckte han verkade för ung, den andra påminde om honom själv.

{.bild}
fil: fem-ar-efter-utoya/breivikskjuter.jpg
storlek: xl
bildtext: Helikopterbilden över Utøya den 22:a juli visar hur Anders Behring Breivik tar sig fram längs ön och skjuter de ungdomar som kommer i hans väg.
foto: NRK
{}

Anders Behring Breivik har vid det här laget tagit livet av ungdomar över hela ön. Med hjälp av de uppgifter som kommer fram efteråt från polis, vittnen och larmsamtal, kan man sammanställa en karta över vägen Breivik tar runt Utøya under de dryga 70 minuter han har på sig att genomföra massakern.

{.bild}
fil: fem-ar-efter-utoya/utoya002.jpg
storlek: wide
{}
[1|kula] – Breivik lämnar färjeläget 17:04 med MS Thorbjørn
[2|kula] – De första dödande skotten avlossas nere vid strandkanten
[3|kula] – Breivik går, efter att ha varit vid huvudbyggnaden, runt på tältplatsen
[4|kula] – Han fortsätter in i cafébyggnaden och skjuter flera ungdomar
[5|kula] – Efter att ha gått ett varv runt ön når han pumphuset där flera har gömt sig
[6|kula] – Breivik forsätter söderut utefter den västra stranden
[7|kula] – NRK:s fotograf fångar Breivik på bild från en helikopter
[8|kula] – Anders Behring Breivik grips av polis

luft:

Flera ungdomar kastar sig i vattnet i ett försök att fly, många träffas av Breiviks skott. 20-årige Bjørn Ihler tror först på Breivik då han utger sig för att vara polis och säger att de är i säkerhet. Men när geväret lyfts kastar sig Bjørn Ihler i vattnet, tillsammans med två pojkar i nioårsåldern vars föräldrar har dödats av Breivik.

{.citat}
citat:  Jag upplevde det som att han siktade på mig. I det ögonblicket kändes det som om själen lämnade kroppen. Jag kände att allt hopp var ute.
av: Bjørn Ihler, överlevande
{}

Samtidigt som polisen nås av allt fler larmsamtal kommer ropen efter hjälp på annat håll. Flera personer som nåtts av uppgifterna om Breiviks massaker skriver inlägg på twitter och vädjar om hjälp. En ung man skriver i versaler att man absolut inte får ringa ungdomarna på Utøya, eftersom de riskerar att bli upptäckta. En annan skriver ett inlägg, direkt från ön.


{.bild}
fil: fem-ar-efter-utoya/tweet1.png
storlek: square
{}
{.bild}
fil: fem-ar-efter-utoya/tweet2.png
storlek: square

{}

luft:
rubrikmager: [17.30 |tid] – Hjälpen dröjer

Allvaret i vad som pågår på lägerön har börjat sjunka in. Polisens insatsstyrka Delta får order om att ta sig de fyra milen från Oslo till Utøya. Först på plats i hamnen i Utvika, på fastlandet, är två polismän från ett lokalt polisdistrikt. De hör skott och ser rök stiga från ön. De ser en träbåt driva i land med skräckslagna ungdomar ombord. Men de måste invänta insatsstyrkan.

Samtidigt fortsätter Breivik att skjuta ner ungdomar, bara några hundra meter bort.
{.citat}
citat: Jag såg honom inte, men hörde honom. Han ropade, jublade, och ropade flera segerrop.
av: Nicoline Bjerge Schie, överlevande
{}

{.bild}
fil: fem-ar-efter-utoya/taltlager.jpg
storlek: xl
bildtext: Bilden togs dagen efter attacken, såhär såg det ut i tältlägret efter att ungdomarna flytt i panik från Anders Behring Brevik.
{}

Nästan en halvtimme efter att samtalet gått iväg om att skicka insatsstyrkan till Utøya har Anders Behring Breivik fortfarande fri lejd att döda. Det har skett ett missförstånd kring vart Delta ska åka för att ta sig över till den lilla ön. Efter att ha kört fel tar de sig till en annan ö med broförbindelse, Storöya.

Avståndet härifrån till ön där massakern pågår är 3,6 kilometer – istället för de 675 meter de hade haft från den hamn där Breivik själv lämnade fastlandet. Den lokala polisen får order att skicka en båt till Storöya för att hämta insatsstyrkan.

rubrik4: Läs mer: [Massiv kritik mot norska polisens insats | http://www.svt.se/nyheter/utrikes/rapport-kan-bli-grund-for-att-staten-stams]

En av dem som samtidigt kämpar för att överleva är Eivind Brox. Han ligger gömd bakom en sten i 40 minuter. Plötsligt kommer en man i polisuniform och säger att de kan komma fram. Sedan börjar han skjuta skoningslöst mot ungdomarna.

{.citat}
citat: När han var klar med de fyra som var framför mig så gör han en rörelse med geväret. Jag väntade på att han skulle skjuta men i stället tar han ett laddningsgrepp, och då springer jag.
av: Eivind Brox, överlevande
{}


rubrikmager: [17.59 |tid] – Det första samtalet

Det har nu gått drygt en timme sedan Anders Behring Breivik sköt sitt första offer. Nu ringer han själv polisen, men hinner bara presentera sig som kommendör i ”den norska antikommunistiska motståndsrörelsen” innan samtalet bryts.

Ungefär en kvart senare ger sig insatsstyrkan till slut av från Storöya i en röd gummibåt, men får motorproblem mitt ute på vattnet och måste få hjälp av civila båtar för att kunna ta sig till Utøya.


{.bild}
fil: fem-ar-efter-utoya/polisbat2.jpg
storlek: wide
bildtext: Gummibåten höll på att sjunka. När insatsstyrkan var på väg ut till Utøya började den ta in vatten och höll på att sjunka.
foto: NRK
{}

Någon gång mellan klockan 18.27 och 18.34 skjuts 16-åriga Andrine Bakken Espeland till döds. En halvtimme tidigare har hon ringt hem i panik och berättat att någon håller på att skjuta på Utøya. Hon blir Anders Behring Breiviks sista offer.

Några av dem som överlever mardrömmen möter journalisterna som väntar på fastlandet. De berättar om vad de nyss upplevt – hur de sett ungdomar springa mot den uniformerade mannen, för att sekunden senare ligga döda på marken.

{.citat}
citat: Alla andra springer mot honom. Han skjuter dem med geväret, och jag ser dem falla i vattnet. Han skjuter dem.
av: Överlevande
{}


rubrikmager: [18.34 |tid] – Det är över

Samtidigt som Anders Behring Breivik ringer en andra gång till polisen för att överlämna sig kommer insatsstyrkan fram till ön. Breivik säger i telefon att uppdraget är "utfört", ett par minuter senare påträffas han av polis. Han kommer gående i ett skogsparti med uppsträckta armar – och grips på plats.
Under de sista 15 minuterna har han hunnit döda minst ett 20-tal ungdomar, kommer polisrapporten senare att visa.

rubrik4: Läs mer: [Breiviks samtal – ord för ord| http://www.svt.se/nyheter/utrikes/breiviks-larmsamtal-ord-for-ord-jag-vill-overlamna-mig]

Snart påbörjas räddningsarbetet på ön. Under tiden skottlossningen pågått har några campinggäster gett sig ut i båtar för att plocka upp de svårt skadade ungdomarna som kämpar i vattnet, flera vittnar senare om hur de blivit beskjutna under räddningsarbetet. 11 ungdomar har lyckats fly ombord båten "Reiulf", de berättar senare om hur Breivik plötsligt dyker upp på bryggan och börjar skjuta mot dem.

{.citat}
citat: När han började skjuta hamnade jag överst i högen av människor som låg i botten av båten. När skottlossningen var över tittade jag över kanten för att se vad som hände, då såg jag Breivik gå bort från bryggan.
av: Eivind Rindal, överlevande
{}


{.bild}
fil: fem-ar-efter-utoya/sdlsy98d60b-nh.jpg
storlek: xl
bildtext: 33 personer träffas av Breiviks skott utan att dö av skadorna.
foto: TT
{}

Det har bara gått några timmar sedan han satt i sitt pojkrum och gjorde de sista förberedelserna för dådet han i flera år planerat. Anders Behring Breivik är nu den värste terrorist Norden någonsin har sett.

Under sina dryga 70 minuter på Utøya hinner han skjuta ihjäl 69 personer. Hälften av Breiviks offer har inte hunnit fylla 17, endast sju är över 25. De yngsta personerna som dödas av skotten är 14 år.


{.iframe}
src: http://pejl.svt.se/stage/fem-ar-efter-otoya-galleri/utoya.html
storlek: xl
height: 500px
{}

Anders Behring Breivik erkänner massmorden direkt . Han kommer senare att dömas till den norska lagens hårdaste straff för massakern på Utøya och attacken i centrala Oslo. Fängelse i 21 år med förvaring, vilket innebär att straffet kan förlängas med fem år i taget så länge Breivik bedöms som farlig.

Totalt dödas 77 personer i de två terrordåden den 22 juli. Norge har drabbats av det värsta illdådet sedan andra världskriget, säger dåvarande statsminister Jens Stoltenberg i ett tal till nationen.


{.citat}
citat: Vårt svar är mer demokrati, större öppenhet och mer humanitet, men aldrig naivitet. Ingen har sagt det vackrare än en AUF-flicka som blev intervjuad av CNN: ’Om en man kan visa så mycket hat, tänk vad mycket kärlek vi alla kan visa tillsammans.’
av: Jens Stoltenberg
{}


{.bild}
fil: fem-ar-efter-utoya/rosen.jpg
storlek: xl
imgix.crop:top
{}

Sommaren 2015 återvände Arbeiderpartiets ungdomsförbund till Utøya. Flera av dem som var med, som förlorade sina nära och kära i terrorattacken fyra år tidigare, åkte till ön för att återigen öppna AUF:s sommarläger. Närmare 1.000 personer deltog.

rubrik4: Läs mer: [Breivik greps – det hände sen | http://www.svt.se/nyheter/utrikes/breivik-greps-vad-hande-sedan]

text:  [Ella Berger | strong], [ella.berger@svt.se | mailto:ella.berger@svt.se], [Martin Hedström | strong], [martin.hedstrom@svt.se | mailto:martin.hedstrom@svt.se]


{.sharebuttons}
title: Fem år efter Utøya
url:http://pejl.svt.se/fem-ar-efter-utoya/
{}

`;

export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/fem-ar-efter-otoya.js
 **/